import React from 'react';
import { useParams } from 'react-router-dom';
import { WEB_APP_ORIGIN } from '../storeConfig';
import DeepLinkShell from '../DeepLinkShell';
import SmartAppCta from '../SmartAppCta';

type GatedKind = 'appointment' | 'chat' | 'wallet' | 'notification' | 'service' | 'generic';

const COPY: Record<GatedKind, { title: string; body: string }> = {
  appointment: {
    title: 'Appointment',
    body: 'Appointment details are private. Open the LookBel app or sign in to view them.',
  },
  chat: {
    title: 'Messages',
    body: 'Conversations are private. Open the LookBel app to continue chatting.',
  },
  wallet: {
    title: 'Wallet',
    body: 'Wallet information is private. Open the LookBel app to manage payouts and balances.',
  },
  notification: {
    title: 'Notification',
    body: 'Open the LookBel app to view your notifications.',
  },
  service: {
    title: 'Service',
    body: 'Open LookBel to view this service and book with the stylist.',
  },
  generic: {
    title: 'LookBel',
    body: 'Open the LookBel app to continue.',
  },
};

interface GatedLanderPageProps {
  kind: GatedKind;
}

/**
 * Privacy-safe interstitial — never renders appointment/chat/wallet payload data.
 */
const GatedLanderPage: React.FC<GatedLanderPageProps> = ({ kind }) => {
  const params = useParams();
  const copy = COPY[kind] || COPY.generic;
  // Touch params so React Router keeps them in the URL without displaying IDs as content
  void params;

  return (
    <DeepLinkShell>
      <div className="dl-card">
        <div className="dl-gated-icon" aria-hidden>
          🔒
        </div>
        <h1 className="dl-name">{copy.title}</h1>
        <p className="dl-meta">{copy.body}</p>
        <SmartAppCta
          title="Open in LookBel"
          subtitle="No details are shown here for privacy."
          webHref={`${WEB_APP_ORIGIN}/login`}
          webLabel="Sign in on the web"
        />
      </div>
    </DeepLinkShell>
  );
};

export default GatedLanderPage;
